var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { usePreviousDistinct } from "react-use";
import { StyledInput, StyledLabel, InputContainer, SuccessIcon, IconContainer, StyledContainer, MetaContainer, MetaInfo, FieldInfo, LabelRow, ErrorIcon, } from "./styled";
import { useFocusedState } from "./use-focused-state";
var defaultHandleMetaDisplay = function (_a) {
    var isDirty = _a.isDirty, instantFeedback = _a.instantFeedback, value = _a.value, prevValue = _a.prevValue, error = _a.error, success = _a.success, touched = _a.touched;
    return touched ||
        Boolean(instantFeedback === "all" && isDirty) ||
        Boolean(instantFeedback === "positiveFirst" && isDirty && success) ||
        Boolean(instantFeedback === "positiveFirst" &&
            isDirty &&
            error &&
            prevValue &&
            value.length < prevValue.length);
}; // if user starts to erase entered data, we provide negative feedback
export var TextInput = function (_a) {
    var error = _a.error, success = _a.success, touched = _a.touched, disabled = _a.disabled, instantFeedback = _a.instantFeedback, iconLeft = _a.iconLeft, iconRight = _a.iconRight, name = _a.name, onFocus = _a.onFocus, onBlur = _a.onBlur, className = _a.className, fieldMessage = _a.fieldMessage, fieldIndicator = _a.fieldIndicator, metaShrinked = _a.metaShrinked, _b = _a.placeholder, placeholder = _b === void 0 ? "" : _b, label = _a.label, isDirty = _a.isDirty, value = _a.value, inputRef = _a.inputRef, _c = _a.handleMetaDisplay, handleMetaDisplay = _c === void 0 ? defaultHandleMetaDisplay : _c, props = __rest(_a, ["error", "success", "touched", "disabled", "instantFeedback", "iconLeft", "iconRight", "name", "onFocus", "onBlur", "className", "fieldMessage", "fieldIndicator", "metaShrinked", "placeholder", "label", "isDirty", "value", "inputRef", "handleMetaDisplay"]);
    var _d = useFocusedState({ onBlur: onBlur, onFocus: onFocus }), focused = _d[0], handleFocus = _d[1], handleBlur = _d[2];
    var prevValue = usePreviousDistinct(value);
    var metaDisplayed = handleMetaDisplay({
        isDirty: isDirty,
        instantFeedback: instantFeedback,
        value: value,
        prevValue: prevValue,
        error: error,
        success: success,
        touched: touched,
        focused: focused,
    });
    var isSuccess = metaDisplayed && success;
    var isError = metaDisplayed && error;
    var errorMessage = isError && error !== true && error;
    var successMessage = isSuccess && success !== true && success;
    return (React.createElement(StyledContainer, { className: className },
        React.createElement(StyledLabel, { disabled: disabled },
            label && (React.createElement(LabelRow, null,
                React.createElement("span", null, label))),
            React.createElement(InputContainer, { focused: focused, success: isSuccess, error: isError, disabled: disabled },
                iconLeft && React.createElement(IconContainer, { disabled: disabled }, iconLeft),
                React.createElement(StyledInput, __assign({}, props, { disabled: disabled, placeholder: placeholder, onBlur: handleBlur, onFocus: handleFocus, name: name, "aria-label": name, iconLeft: iconLeft, iconRight: iconRight, type: "text", value: value, ref: inputRef })),
                iconRight && React.createElement(IconContainer, { disabled: disabled }, iconRight),
                metaDisplayed && error && (React.createElement(IconContainer, { disabled: disabled },
                    React.createElement(ErrorIcon, { name: "cross_s" }))),
                metaDisplayed && success && (React.createElement(IconContainer, { disabled: disabled },
                    React.createElement(SuccessIcon, { name: "checkmark_s" }))))),
        !metaShrinked && (React.createElement(MetaContainer, null,
            React.createElement(FieldInfo, { success: isSuccess, error: isError }, (isError && errorMessage) || (isSuccess && successMessage) || fieldMessage),
            React.createElement(MetaInfo, null, fieldIndicator)))));
};
